import { axios } from "@/util"
import Vue from 'vue'

let axiosPlugin = {
    install (Vue, options) {
        Vue.prototype.$axios = axios;
    }
}
Vue.use(axiosPlugin)